import { colors, spacing, typography } from "../../../styles/theme.js";
import { useMemo } from "react";

const styles = {
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `${spacing.xl}px ${spacing.md}px ${spacing.md}px ${spacing.xl}px`,
  },
  title: {
    fontSize: typography.fontSize.lg,
    fontWeight: typography.fontWeight.bold,
    color: colors.text,
    margin: "0 0 8px 0",
  },
  subtitle: {
    color: colors.textSecondary,
    margin: 0,
    fontSize: typography.fontSize.md,
  },

  saveButton: {
    marginTop: "8px",
    padding: "8px 16px",
    borderRadius: 4,
    border: "none",
    fontWeight: typography.fontWeight.bold,
    color: colors.white,
    background: colors.primary,
    fontSize: typography.fontSize.md,
    cursor: "pointer",
    marginRight: 10,
    minWidth: 110,
    transition: "background-color 0.5s, opacity 0.5s",
  },
  saveButtonHover: {
    background: colors.primaryHover,
  },
  success: {
    background: colors.success,
    opacity: 0.6,
  },
  error: {
    color: colors.textDanger,
    fontWeight: typography.fontWeight.medium,
    fontSize: typography.fontSize.sm,
    marginLeft: spacing.md,
  },
  successMessage: {
    color: colors.textSuccess,
    fontWeight: typography.fontWeight.medium,
    fontSize: typography.fontSize.sm,
    marginLeft: spacing.md,
  },
};

export const PlaylistBuilderHeader = ({
  handleSave,
  saveMessage,
  successfulSave,
  saveError,
  saving,
}) => {
  const buttonText = useMemo(() => {
    if (saving) return "Saving...";
    if (successfulSave) return "Success!";
    return "Save";
  }, [saving, successfulSave]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: spacing.xxl,
      }}
    >
      <div style={styles.header}>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <h1 style={styles.title}>Playlist Builder</h1>
        </div>
        <button
          style={{
            ...styles.saveButton,
            alignSelf: "flex-start",
            opacity: saving ? 0.6 : 1,
            ...(successfulSave && styles.success),
          }}
          disabled={saving}
          onClick={handleSave}
          type="button"
        >
          {buttonText}
        </button>
        {saveError && <span style={styles.error}>{saveError}</span>}
      </div>
    </div>
  );
};

export default PlaylistBuilderHeader;
